import * as React from "react";
import {cx} from "emotion";

import "./edit-qr-field.scss";

import {cs}              from "@Common/react/chain-services";
import {consumeContext}  from "@Common/react/context";
import {UseState}        from "@Common/react/use-state";
import {Button}          from "@Common/tools/cc-integration/ui/button/button";
import {TypeUrl}         from "@Common/ui-components/heavy/item-options/modules/redirect-url/types/type-url/type-url";
import {buildUrlQuery}   from "@Common/utils/build-url-query";
import {decimalToBase64} from "@Common/utils/strings";

export const EditQrField = ( props ) =>  cs(
    consumeContext("company"),
    consumeContext("systemConstants"),
    ["inputData", (_, next) => UseState({
        initValue: props.cc['inputData']?.['qrValues']?.[props.qrField.side]?.[props.qrField.id],
        next,
    })],
    ["qrType", (_, next) => UseState({
        initValue: props.qrField?.qrType?.includes( props.qrField?.lineItemValue ) ?
            props.qrField?.lineItemValue
            : (
                props.qrField?.qrType?.includes(props.cc?.inputData?.qrValues?.tracking?.redirectType) ?
                    props.cc?.inputData?.qrValues?.tracking?.redirectType
                    : ( props.qrField?.qrType?.[0] ?? '' )
                ),
        next,
    })],
    ["show", (_, next) => UseState({next})],
    ["typeUrl", ({inputData, show}, next) => TypeUrl({
        disabled: false,
        liveValue: props.cc?.qrCodeUrlValue || inputData.value?.['url'],
        path: ["tracking", "redirectUrl"],
        readOnly: props.qrField?.qrPrefs?.['url']?.readOnly,
        onChange: (e) => {
            props.cc.setQrValue(props.qrField?.side, props.qrField?.id, 'url', e.target.value);
            inputData.onChange({...inputData.value, "url": e.target.value});
            show.onChange(false);
        },
        next
    })],
    ({company, inputData, qrType, show, systemConstants, typeUrl}) => {
        try{
            let qrField = props.qrField;
            return <div style={{display: props.show? 'block': 'none'}}>
                <div className="buttons">
                    {props.qrField?.qrType ?
                    props.qrField?.qrType.map((qrOption, i) => (
                        <button
                            key={i}
                            className={qrOption === qrType.value ? "selected" : ''}
                            onClick={() => {
                                qrType.onChange(qrOption);
                                show.onChange(false);
                            }}
                            xd-qa-type="button"
                            xd-qa-name={qrOption}
                        >
                            {qrOption}
                        </button>
                    ))
                    : "No QR types selected"}
                </div>
                { qrType.value === 'vcard' ?
                    <div className="vcard">
                        <div className="qr-form">
                            {Object.entries({
                                'First Name': 'firstName', 'Last Name': 'lastName', 'Title': 'title', 'Organization': 'org', 'Email Address': 'email',
                                'Phone Number': 'phone', 'Fax Number': 'fax', 'Street Address': 'streetAddress', 'City': 'city', 'State': 'state',
                                'Zip/Postal Code': 'zip', 'Country': 'country', 'Website URL': 'url'
                            }).map(([label, key]) => (
                                <div className="input-container" key={key}>
                                    <label>{label}{qrField?.qrPrefs?.[key]?.isRequired ? <span className="required"> *</span>:''}</label>
                                    {qrField?.qrPrefs?.[key]?.prefix}
                                    <input type="text" xd-qa-type="input"
                                        defaultValue={inputData.value?.[key]}
                                        readOnly={qrField?.qrPrefs?.[key]?.readOnly}
                                        className={!inputData.value?.[key] && qrField?.qrPrefs?.[key]?.isRequired ? 'requiredInput': ''}
                                        onChange={(e)=> {
                                            props.cc.setQrValue(qrField.side, qrField.id, key, e.target.value);
                                            inputData.onChange({...inputData.value, [key]: e.target.value});
                                            show.onChange(false);
                                        }}
                                    />
                                    {qrField?.qrPrefs?.[key]?.specifiedDomain ? (
                                        props.cc.sourceData?.xd?.templateOptions?.assignedDomain ? props.cc.sourceData?.xd?.templateOptions?.assignedDomain
                                            : (props.cc.sourceData?.xd?.office?.assignedDomain ? props.cc.sourceData?.xd?.office?.assignedDomain
                                            : props.cc.sourceData?.xd?.company?.prefs?.assignedDomain ?? '' )
                                        ) : ''
                                    }
                                </div>
                            ))}
                        </div>
                        <button
                            className="make-qr-button"
                            xd-qa-type="button"
                            xd-qa-name="Generate QR Code"
                            onClick={()=>{getVcardCode(qrField, inputData.value, props.cc, show)}}
                        >
                            {"Generate QR Code"}
                        </button>
                        <button
                            className="delete-qr-button"
                            xd-qa-type="button"
                            xd-qa-name="Delete QR Code"
                            onClick={()=>{deleteQRCode(qrField, props.cc)}}
                        >
                            {"Delete QR Code"}
                        </button>
                        {!!show.value && <div className="required">Missing Required Fields.</div>}
                    </div>
                    : qrType.value === 'url' ?
                        <div className="url">
                            <div className="qr-form">
                                <div className="input-container">
                                    <label>Website URL<span className="required"> *</span></label>
                                    {qrField?.qrPrefs?.['url']?.prefix}
                                    <div>
                                        <div className="line1">
                                            {typeUrl.renderControl({})}
                                        </div>

                                        {!typeUrl.disabled && typeUrl.errorHandling && (
                                            <div className="error">
                                                <div className={cx("message", {inactive: typeUrl.editor.valid})}>
                                                    {typeUrl.errorHandling.message}
                                                </div>

                                                {typeUrl.errorHandling.controls && (
                                                    <div className="controls">
                                                        {typeUrl.errorHandling.controls}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <Button
                                buttonText={qrField?.lineItemValue ? "Generate QR Code & Save" : "Generate QR Code"}
                                xdQaName={qrField?.lineItemValue ? "Generate QR Code & Save" : "Generate QR Code"}
                                disabled={!!props.disableSaves?.value || !typeUrl?.editor?.valid}
                                className="make-qr-button"
                                onClick={async () => {
                                    if( qrField?.lineItemValue ) {
                                        await getTrackingCode(
                                            company, qrField, qrType.value, props.cc, props.disableSaves, inputData.value,
                                            props.itemId, props.itemSaver, show
                                        );
                                    }
                                    else {
                                        getUrlCode(qrField, inputData.value, props.cc, show);
                                    }

                                }}
                            />
                            {!qrField?.isRequired && <button
                                className="delete-qr-button "
                                xd-qa-type="button"
                                xd-qa-name="Delete QR Code"
                                onClick={()=>{deleteQRCode(qrField, props.cc)}}
                            >
                                {"Delete QR Code"}
                            </button>}
                            {!!show.value && <div className="required">Missing Required Fields.</div>}
                        </div>
                        : (qrType.value === 'homevalue' || qrType.value === 'xpresslinks') ? <>
                            {props.itemId ? <>
                                <div className="qr-link">
                                    <a href={getTrackingUrl(company, qrType.value, props.itemId, systemConstants)}
                                        target="_blank"
                                        xd-qa-type="link"
                                        xd-qa-name={"Preview " + qrType.value}
                                    >
                                        {qrType.value === 'homevalue' ? "Preview Home Value" : "Preview Xpress Links"}
                                    </a>
                                </div>
                                {qrType.value === 'xpresslinks' ? <div>Please click "Save" to view proofs in Xpress Links preview.</div>
                                : <div>Note: we are unable to return property value for multi-family residences or commercial properties.</div>}
                            </>
                            : <></>}
                            <div className="qr-footer">
                                <Button
                                    buttonText="Generate QR Code & Save"
                                    xdQaName="Generate QR Code & Save"
                                    disabled={!!props.disableSaves?.value}
                                    className="make-qr-button"
                                    onClick={async () => {
                                        await getTrackingCode(
                                            company, qrField, qrType.value, props.cc, props.disableSaves, null,
                                            props.itemId, props.itemSaver, show
                                        );
                                    }}
                                />
                                {!qrField?.isRequired && <Button
                                    buttonText="Delete QR Code"
                                    xdQaName="Delete QR Code"
                                    disabled={!!props.disableSaves?.value}
                                    className="delete-qr-button"
                                    onClick={async () => {
                                        await deleteQRCode(qrField, props.cc);
                                    }}
                                />}
                                {!!show.value && <div className="required">Missing Required Fields.</div>}
                            </div>
                        </> : ''
                }
            </div>
        }
        catch(e){
            console.log("failed", e);
            return <div></div>
        }
    }
);

const getVcardCode = (qrField, inputData, cc, show) => {
    let data = '';
    let error = false;
    ['firstName', 'lastName', 'title', 'tel', 'fax', 'email', 'org', 'streetAddress', 'city', 'state', 'zip', 'country'].forEach((value)=>{
        if(!error && qrField?.qrPrefs?.[value]?.isRequired
            && !inputData?.[value]) {
            error = true;
        }
    });
    if(!error) {
        let assignedDomain = qrField?.qrPrefs?.['email']?.specifiedDomain ? (
            cc.sourceData?.xd?.templateOptions?.assignedDomain ? cc.sourceData?.xd?.templateOptions?.assignedDomain
                : (cc.sourceData?.xd?.office?.assignedDomain ? cc.sourceData?.xd?.office?.assignedDomain
                : cc.sourceData?.xd?.company?.prefs?.assignedDomain ?? '' )
            ) : '';
        let email = inputData.email ?? ''
        if( email && assignedDomain ) {
            email = email.split('@')[0];
            if( email ) {
                email = email + assignedDomain;
            }
        }
        let prefix = qrField?.qrPrefs?.['url']?.prefix;
        let url = inputData.url ?? ''
        if( url && prefix ) {
            url = prefix + url;
        }

        data = `BEGIN:VCARD%0AVERSION:3.0%0AFN:${inputData.firstName ?? ''} ${inputData.lastName ?? ''}%0A` +
            `N:${inputData.lastName ?? ''};${inputData.firstName ?? ''}%0A` +
            `TITLE:${inputData.title ?? ''}%0A` +
            `TEL;type=WORK;type=VOICE;type=pref:${inputData.phone ?? ''}%0A` +
            `TEL;type=WORK;type=FAX:${inputData.fax ?? ''}%0A` +
            `EMAIL;type=INTERNET;type=WORK;type=pref:${email ?? ''}%0A` +
            `ORG:${inputData.org ?? ''}%0A` +
            `ADR;type=WORK;type=pref:;;${inputData.streetAddress ?? ''};${inputData.city ?? ''};${inputData.state ?? ''};${inputData.zip ?? ''};${inputData.country ?? ''}%0A` +
            `URL;type=WORK;type=pref:${url ?? ''}%0A` +
            `END:VCARD`;

        getQrCode(data, qrField, cc);
        cc.setTrackingValue({redirectType: 'vcard'});
    }
    else {
        show.onChange(true);
    }
};


const getUrlCode = (qrField, inputData, cc, show) => {
    let prefix = qrField?.qrPrefs?.['url']?.prefix;
    let url = inputData.url ?? ''
    if( url && prefix ) {
        url = prefix + url;
    }

    if( !url ) {
        show.onChange(true);
    }
    else {
        getQrCode(url, qrField, cc);
        cc.setTrackingValue({redirectType: 'url', redirectUrl: url});
    }
};

const getTrackingCode = async ( company, qrField, type, cc, disableSaves, inputData, itemId, itemSaver, show ) => {
    let redirectUrl = inputData?.url;
    if( !company?.idCompany || !itemId || ( type == 'url' && !redirectUrl ) ) {
        show.onChange(true);
    }
    else {
        let url = `${window.location.origin}/next/track.php?c=${company?.idCompany}&o=${decimalToBase64(itemId)}&p=1`;
        disableSaves?.onChange(true);
        await getQrCode(url, qrField, cc);
        if(type == 'url') {
            let prefix = qrField?.qrPrefs?.['url']?.prefix;
            if( redirectUrl && prefix ) {
                redirectUrl = prefix + redirectUrl;
            }
            cc.setTrackingValue({redirectType: type, redirectUrl});
        }
        else {
            cc.setTrackingValue({redirectType: type});
        }
        await cc.save();
        //apm2 is an auto saver, but xpresso needs the manual save for item. Save needed to update thumbnails for xpresslinks display.
        await itemSaver?.save();
        disableSaves?.onChange(false);
    }
};

const getTrackingUrl = ( company, type, itemId, systemConstants ) => {
    let url = '';
    if( type === 'homevalue' && itemId ) {
        const data = {
            idCompany: company?.idCompany,
            idOrder: itemId,
            preview: true,
        };
        const jsonString = JSON.stringify(data);
        const base64String = btoa(jsonString);

        url = systemConstants?.value?.MN_HOMEVALUE_URL + encodeURIComponent(base64String);
    }
    else if( type === 'xpresslinks' && itemId ) {
        const data = {
            idCompany: company?.idCompany,
            idOrder: itemId,
        };
        const jsonString = JSON.stringify(data);
        const base64String = btoa(jsonString);
        url = systemConstants?.value?.MN_XPRESSLINKS_URL + encodeURIComponent(base64String);
    }
    return url;
};

const getQrCode = async (data, qrField, cc) => {
    if(data){
        let imageUrl = `${cc.ccHost}/xdapi/api/create-qr${buildUrlQuery({data})}`;
        await cc.applyQrImage(qrField, imageUrl);
    }
};

const deleteQRCode = async (qrField, cc) => {
    await cc.applyQrImage(qrField, null);
    cc.setTrackingValue(null);
};